<fullscreen-page>

  <content-column [helpSwitch]="true" look="light">
    <div class="p-2 flex-fill overflow-hidden" slot="content">

      <dx-data-grid #dataSourceGrid
                    (onRowPrepared)="onRowPrepared($event)"
                    (onRowRemoved)="onRowRemoved($event)"
                    (onSelectionChanged)="onSelectionChanged($event)"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    [allowColumnReordering]="true"
                    [allowColumnResizing]="true"
                    [dataSource]="productDataSources"
                    [height]="'100%'"
                    [repaintChangesOnly]="true"
                    [rowAlternationEnabled]="true"
                    [selection]="{ mode: 'multiple', showCheckBoxesMode: 'always', allowSelectAll: false}"
                    [showBorders]="true"
                    id="dataSourceGrid"
                    keyExpr="id">
        <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
        <dxo-search-panel [visible]="true"
                          [width]="240"
                          placeholder="Suche …">
        </dxo-search-panel>
        <dxo-search [enabled]="true"></dxo-search>
        <dxo-editing [allowAdding]="false"
                     [allowDeleting]="true"
                     [allowUpdating]="false"
                     mode="cell"></dxo-editing>
        <dxo-paging [enabled]="true"></dxo-paging>
        <div *dxTemplate="let toolbaritem of 'newDataSourceButtonTemplate'">
          <div class="d-flex gap-2" id="addButton">
            <dx-button (onClick)="showAddOrUpdateDataSource()"
                       stylingMode="text"
                       text="{{ 'Neuer Lieferant' | translate }}"
                       type="default">

            </dx-button>
          </div>
        </div>
        <div *dxTemplate="let toolbaritem of 'applyDataSourceChangesButtonTemplate'">
          <div class="d-flex gap-2" id="applyDataSourceChangesButton">
            <dx-button (onClick)="applyDataSourceChanges()"
                       [disabled]="!isApplyDataSourceButtonActiv()"
                       [hint]="applyButtonHint"
                       [text]="applyButtonText()"
                       stylingMode="text"
                       type="default">
            </dx-button>
          </div>
        </div>
        <div *dxTemplate="let toolbaritem of 'exportDataSourceButtonTemplate'">
          <div class="d-flex gap-2" id="exportDataSourceButton">
            <dx-button (onClick)="exportDataSource()"
                       icon="export"
                       stylingMode="text"
                       text="{{ 'Excel Export' | translate }}"
                       type="default">

            </dx-button>
          </div>
        </div>
        <div *dxTemplate="let toolbaritem of 'importDataSourceButtonTemplate'">
          <div class="d-flex gap-2" id="importDataSourceButton">
            <dx-button (onClick)="showImportDataSource()"
                       icon="import"
                       stylingMode="text"
                       text="{{ 'Excel Import' | translate }}"
                       type="default">

            </dx-button>
          </div>
        </div>


        <dxi-column [allowFiltering]="false" [allowSorting]="false" [width]="60" caption="" cellTemplate="imageCellTemplate" dataField="logoFile"></dxi-column>
        <div *dxTemplate="let data of 'imageCellTemplate'" style="overflow:visible">
          <div>
            <span *ngIf="!data.value" class="glyphicon glyphicon-picture" style="font-size: 40px;"></span>
            <img *ngIf="data.value" id="link{{data.rowIndex}}" src="{{data.value}}" style="height: 40px;" />
          </div>
        </div>

        <dxi-column dataField="kreditorNr" title="{{ 'KreditorNr' | translate }}"></dxi-column>
        <dxi-column dataField="name" title="{{ 'Name' | translate }}"></dxi-column>
        <dxi-column dataField="type" title="{{ 'Typ' | translate }}" [calculateDisplayValue]="typeDisplay"></dxi-column>
        <dxi-column dataField="alternativeNames" title="{{ 'Alternative Namen' | translate }}"></dxi-column>
        <dxi-column [allowEditing]="false"
                    [showEditorAlways]="true"
                    caption="{{ 'Letzte Ändernung' | translate }}"
                    dataField="lastUpdate"
                    dataType="datetime"
                    editCellTemplate="lastUpdateTemplate">
        </dxi-column>
        <div *dxTemplate="let cellInfo of 'lastUpdateTemplate'">
          <dx-date-box (onValueChanged)="cellInfo.setValue($event.value)"
                       [(value)]="cellInfo.value"
                       [readOnly]="true"
                       type="datetime"></dx-date-box>
        </div>
        <dxi-column [allowEditing]="false"
                    [showEditorAlways]="true"
                    caption="{{ 'Letzte Synchronisierung' | translate }}"
                    dataField="lastSync"
                    dataType="datetime"
                    editCellTemplate="lastSyncTemplate">
        </dxi-column>
        <div *dxTemplate="let cellInfo of 'lastSyncTemplate'">
          <dx-date-box (onValueChanged)="cellInfo.setValue($event.value)"
                       [(value)]="cellInfo.value"
                       [readOnly]="true"
                       type="datetime"></dx-date-box>
        </div>
        <dxi-column caption="{{ 'Sicherheitsinformationen gepflegt?' | translate }}" cellTemplate="smileyTemplate">
          <div *dxTemplate="let cell of 'smileyTemplate'">
            <span [ngClass]="getSmileyClass(cell.data)"
                  class="smiley">
              {{ getSmileyEmoji(cell.data) }}
            </span>
          </div>
        </dxi-column>
        <dxi-column caption="" cellTemplate="editDataSourceTemplate" width="40"></dxi-column>
        <div *dxTemplate="let d of 'editDataSourceTemplate'">
          <a (click)="showAddOrUpdateDataSource(d.data)"
             class="dx-icon-edit mr-2"
             title="{{ 'Lieferant bearbeiten' | translate }}"></a>
        </div>
      </dx-data-grid>
    </div>
  </content-column>
  <np-edit-datasource (saved)="onEditSaved($event)"
                      [(visible)]="popupVisible"
                      [dataSource]="newOrUpdateProductDataSource"
                      [editMode]="editMode"
                      [relatedBrands]="relatedBrands"/>

  <dx-popup [(visible)]="startMacroDialogVisible"
            [height]="250"
            [hideOnOutsideClick]="true"
            [title]="hasSelection ? ('Synchronisierung starten' | translate) : ('Alle Änderungen anwenden' | translate)"
            [width]="400">

    <dxi-popup-toolbar-item [options]="{ stylingMode: 'outlined', text: hasSelection ? ('Synchronisierung starten' | translate) : ('Alle Änderungen anwenden' | translate), onClick: startApplyChangesMakro }"
                      location="after"
                      toolbar="bottom"
                      widget="dxButton">
    </dxi-popup-toolbar-item>
    <div *dxTemplate="let data of 'content'">
      <p>{{ 'Wird kein Startdatum angegeben, wird das Makro direkt ausgeführt.' | translate}}</p>
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Startzeitpunkt' | translate }}</div>
        <div class="dx-field-value">
          <dx-date-box [(value)]="selectedMacroStartDate"
                       displayFormat="dd.MM.yyyy HH:mm"
                       type="datetime">
          </dx-date-box>
        </div>
      </div>
    </div>
  </dx-popup>
</fullscreen-page>

<dx-popup *ngIf="importExcelVisible"
          [(visible)]="importExcelVisible"
          [dragEnabled]="false"
          [height]="350"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [showTitle]="true"
          [width]="600"
          contentTemplate="popupContent2"
          title="{{ 'Lieferanten importieren' | translate }}">
  <div *dxTemplate="let data of 'popupContent2'">
    <dx-file-uploader #fileUploader
                      (onBeforeSend)="onBeforeSendUpload($event)"
                      (onUploaded)="onImportUploaded()"
                      [chunkSize]="10000000"
                      [multiple]="false"
                      accept=".xlsx"
                      name="file"
                      uploadMode="instantly"
                      uploadUrl="api/import/ImportDataSourcesChunky">
    </dx-file-uploader>
  </div>
</dx-popup>
